import React from 'react';
import { useFluentTheme } from '../../theme/index';
import Text from '../../atoms/Text';
import Button from '../../atoms/Button';
import { Stack, Modal } from '@fluentui/react';
import getStyles from './TermsModal.styles';

export interface TermsModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ showModal, setShowModal }) => {
  const theme = useFluentTheme();
  const styles = getStyles(theme);
  const modalStyles = {
    main: {
      width: '800px',
    },
    scrollableContent: {
      display: 'contents',
      flexDirection: 'column-reverse',
    },
  };
  const contents = [
    {
      heading: 'The vdoDOC Platform',
      body: 'The Service is designed to provide a platform that enables you to share your personal health information.',
    },
    {
      heading: 'You Authorize Us To Use Your Data In Accordance With Our Privacy Policy',
      body: `You hereby authorize the collection, storage, integration, transmission 
and sharing of personal health information further described herein (including in
our Privacy Policy).`,
    },
    {
      heading: 'Notifications and Alerts',
      body: `We post electronic communications on the Site or 
within the Services to keep you informed. Notices and other information may be 
provided by text, on the Site or Services or through a link to the appropriate 
page, accessible through any standard, commercially available internet browser.`,
    },
    {
      heading: 'If You Consent To It, We May Send You Electronic Communications',
      body: `If 
you provide us with your e-mail address and your consent, you agree to receive 
all required notices and information delivered to your email address that we 
have on file for you. In such case, it is your responsibility to promptly update us 
with your complete, accurate contact information, or change your information, 
including email address, as appropriate. Your consent to receive 
communications electronically is valid until your transaction with a Customer is 
completed and you end your relationship with us. You may print a copy of any 
electronic communication and retain it for your records. We reserve the right to 
terminate or change how we provide electronic communications and will provide
you with appropriate notice in accordance with applicable law.`,
    },
    {
      heading: 'If You Use Any Of Our Mobile Services, You Are Responsible For Connectivity',
      body: `The Service includes certain services that are available via a 
mobile device, including (i) the ability to upload data or other content to the 
Service via a mobile device, (ii) the ability to browse the Service and the Site 
from a mobile device and (iii) the ability to access certain features through an 
application downloaded and installed on a mobile device (collectively, the 
“Mobile Services”). To the extent you access the Service through a mobile 
device, your wireless service carrier”s standard charges, data rates and other 
fees may apply. In addition, downloading, installing, or using certain Mobile 
Services may be prohibited or restricted by your carrier, and not all Mobile 
Services may work with all carriers or devices. We May Send You Text Messages:
By using the Services, you consent to receive information from us via SMS 
and/or MMS messages sent through an automated telephone dialing system 
(“Text Service”), even if you have opted in to the National Do Not Call List, any 
state Do not Call List, or the internal Do Not Call List of any company. You may 
be required to respond to an initial message as instructed to complete your 
registration and confirm enrollment in the Text Service. The enrollment process 
will disclose the program, frequency of messages, and options to cancel your 
enrollment. You do not have to participate in the Text Service in order to use the
Service. In the event you no longer want to participate in the Text Service, you 
agree to notify us directly. In the event you change or deactivate your mobile 
telephone number, you agree to promptly update your account information to 
ensure that your messages are not sent to the person that acquires your old 
number. There is no additional charge for the Text Service, but your mobile 
carrier”s standard message and data rates apply to any messages you send or 
receive through the Text Service, including confirmations and subsequent texts. 
Your carrier may prohibit or restrict certain mobile features and certain mobile 
features may be incompatible with your carrier or mobile device. We are not 
liable for any delays in the receipt of, or any failures to receive, any SMS or MMS
messages, as delivery is subject to effective transmission by your mobile carrier 
and compatibility of your mobile device. Please contact your mobile carrier if 
you have any questions regarding these issues or your mobile data and 
messaging plan. As described in the Text Service enrollment and welcome 
messages, including messages sent to a shortcode associated with the Text 
Service or by reply to any message you receive from us, you may text “STOP” to
cancel or “HELP” for customer support information. If you choose to cancel your 
Text Service, you agree to receive a final text message from the Text Service 
confirming your cancellation. Age Requirements:  If you are under 13 years of 
age, you are not authorized to use the Service, with or without registering.  In 
addition, if you are under 18 years of age, you may use the Service, with or 
without registering, only with the approval of your parent or guardian. You can 
elect to access and use vdoDOC, subject to the My vdoDOC terms (set forth in 
section “Your Registration Obligations For My vdoDOC :” below). 
Your Registration Obligations For My vdoDOC : If you elect to use My vdoDOC , 
you will be required to register and create an account with vdoDOC .  If you 
choose to create an account with us, you agree to provide and maintain true, 
accurate, current and complete information about yourself as prompted by our 
registration form.  Registration data and certain other information about you are
governed by our Privacy Policy. vdoDOC may verify your identity, which may 
require asking you for information such as your full address, your date of birth, 
and/or requiring you to take steps to confirm ownership of your email address or
records ownership or verifying information you provide. If you do not provide 
this information or vdoDOC cannot verify your identity, we can refuse to allow 
you to use My vdoDOC .  If you provide information of any kind which is untrue, 
inaccurate, not current or incomplete, or we have reasonable grounds to 
suspect that such information is untrue, inaccurate, not current or incomplete, 
we reserve the right to suspend or terminate your access to My vdoDOC .`,
    },
  ];
  const renderContent = () => {
    return contents.map((content, index) => (
      <Stack className={styles.contentContainer} horizontalAlign="start" key={`aggrement-${index}`}>
        <Text variant="mediumBold" styles={{ root: { color: '#CCD7E0' } }}>
          {content.heading}
        </Text>
        :
        <Text variant="mediumSemibold" styles={{ root: { color: '#CCD7E0' } }}>
          {content.body}
        </Text>
      </Stack>
    ));
  };
  return (
    <Modal
      isOpen={showModal}
      isBlocking={false}
      className={styles.modalWrapper}
      styles={modalStyles}
    >
      <Stack
        horizontalAlign="center"
        verticalAlign="center"
        className={styles.modalContainer}
        tokens={{ childrenGap: 20 }}
      >
        <Text variant="sectionTitle" styles={{ root: { color: '#585858' } }}>
          Terms and Conditions
        </Text>
        <Text variant="mediumSemibold" styles={{ root: { color: '#585858' } }}>
          Access and Use of the Service
        </Text>
        {renderContent()}
        <Button onClick={() => setShowModal(false)}>Agree</Button>
      </Stack>
    </Modal>
  );
};
export default TermsModal;
